// RoleDropdown.js
import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../../api';

const RoleDropdown = ({ 
  value, 
  onChange, 
  className, 
  disabled, 
  onBlur,
  showAdmin = false   // New prop: true = show Admin, false = hide Admin
}) => {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get('/roles');
        let fetchedRoles = response.data || [];

        // Hide Admin role unless explicitly allowed
        if (!showAdmin) {
          fetchedRoles = fetchedRoles.filter(role => 
            role.name !== 'Admin' && 
            role.name !== 'admin' && 
            !role.name.toLowerCase().includes('administrator')
          );
        }

        setRoles(fetchedRoles);
      } catch (error) {
        console.error('Error fetching roles:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchRoles();
  }, [showAdmin]);

  if (loading) {
    return (
      <select className="form-select" disabled>
        <option>Loading roles...</option>
      </select>
    );
  }

  return (
    <select
      className={`form-select ${className || ''}`}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      required={!showAdmin} // Only required when adding user
      disabled={disabled || loading}
      name="role_id"
    >
      <option value="">{showAdmin ? 'All Roles' : 'Select Role'}</option>
      
      {roles.map((role) => (
        <option key={role.id} value={role.id}>
          {role.name}
        </option>
      ))}
    </select>
  );
};

export default RoleDropdown;